module.exports = __webpack_public_path__ + "static/media/intro.89ba7676.mp3";